/**
 * API Configuration
 * Uses environment variables to determine API endpoints
 */

// Function to get localhost URL based on environment
const getLocalApiUrl = () => {
  // Check if we're in a browser and on Android emulator
  if (typeof window !== 'undefined' && navigator.userAgent.includes('Android')) {
    // Use configurable network IP for Android browsers
    const networkIp = import.meta.env.VITE_NETWORK_IP || '192.168.1.126';
    return `http://${networkIp}:3000`;
  }
  // Default to localhost for desktop browsers and iOS
  return 'http://localhost:3000';
};

// Base API endpoints
const API_ENDPOINTS = {
  local: {
    base: getLocalApiUrl(),
    trpc: `${getLocalApiUrl()}/trpc`
  },
  test: {
    base: 'https://trackplicant-api-test-gtbxe4f3amdhftfc.centralus-01.azurewebsites.net',
    trpc: 'https://trackplicant-api-test-gtbxe4f3amdhftfc.centralus-01.azurewebsites.net/trpc'
  },
  production: {
    base: 'https://trackplicant-api.azurewebsites.net',
    trpc: 'https://trackplicant-api.azurewebsites.net/trpc'
  }
};

// Get environment from VITE_API_ENVIRONMENT (defaults to 'local')
const apiEnvironment = import.meta.env.VITE_API_ENVIRONMENT || 'local';

// Validate environment and get endpoints
const getApiEndpoints = () => {
  if (apiEnvironment in API_ENDPOINTS) {
    return API_ENDPOINTS[apiEnvironment as keyof typeof API_ENDPOINTS];
  }
  
  console.warn(`Invalid VITE_API_ENVIRONMENT: ${apiEnvironment}. Falling back to 'local'.`);
  return API_ENDPOINTS.local;
};

const endpoints = getApiEndpoints();

// Export configuration
export const apiConfig = {
  environment: apiEnvironment,
  baseUrl: endpoints.base,
  trpcUrl: endpoints.trpc
};

// Log config in development
if (import.meta.env.DEV) {
  console.log(`[API] Using '${apiEnvironment}' API environment`);
  console.log(`[API] Base URL: ${apiConfig.baseUrl}`);
  console.log(`[API] tRPC URL: ${apiConfig.trpcUrl}`);
}